import React from 'react';
import classNames from './style.module.scss';
import AccordionItem from '../../custom-reports/custom-visual-inspection/accordion-item';

interface FAQItem {
    title: string;
    body: string;
}

const FAQs: React.FC = () => {
    return ( 
        <div className={classNames.faqs}>
            <h2> <i className="bi bi-info-circle-fill"></i> Frequently Asked Questions</h2>

            {faqItems.map((faqItem) => (
                <AccordionItem key={faqItem.title} isActive title={faqItem.title}>
                    <div className={classNames.faqsBody}>
                        {faqItem.body}
                    </div>
                </AccordionItem>
            ))}
        </div>
     );
};

const faqItems: FAQItem[] = [
    {
        title: 'I have poor network and i need to complete my report. What do I do?',
        body: 'You can go offline and then complete your report. Once done, Turn on your internet to synchronize and save.'
    },
    {
        title: 'I can\'t find my Inspected Items. It is showing red. What do i do?',
        body: 'Please ensure you have good internet and refresh the page a few times. If the issue persists, kindly contact support.'
    },
    {
        title: 'I have more pictures to add. What do I do?',
        body: 'Kindly forward your request through Mr. Sooravan.'
    },
    {
        title: 'Pictures are missing on my PDF? What do I do?',
        body: `
            Follow the instructions below to clear your cache.

            1. Press the shift + ctrl + i buttons together
            2. Press and hold the refresh button
            3. Click on the 'empty cache and hard reload' button.

            If the issue persists after this, kindly contact support.
        `
    },
] 
 
export default FAQs;